export enum UserRoles {
  SuperAdmin = 0,
  Admin = 1,
  Audit = 2,
  PracticeUser = 3
}
